import React from 'react'
import { ApplicationFlowTheme, ResultSkinViewModel } from '../types'
import ResultSkin from './result-skin'

interface Props {

  /** 旧结果容器投影出的展示数据。 */
  model: ResultSkinViewModel

  /** 由旧容器解析的渠道主题。 */
  theme: ApplicationFlowTheme

  /** 返回意图，最终委托旧容器处理原有路由语义。 */
  onBack?: () => void

  /** 下载用户意图，最终委托旧容器的下载函数。 */
  onDownload: () => void

  /** 重新申请意图，最终委托旧容器的既有跳转。 */
  onRetryApplication?: () => void

  /** 顶部轮播产品的申请意图，最终由旧结果容器处理申请和联登。 */
  onApplyFeaturedProduct?: (productId: string) => void

  /** 顶部轮播产品展示时，最终由旧结果容器执行原有曝光上报。 */
  onExposeFeaturedProduct?: (productId: string) => void

  /** 列表推荐产品的申请意图，最终由旧结果容器处理申请和联登。 */
  onApplyRecommendedProduct?: (productId: string) => void
}

/**
 * ResultSkinContainer — 结果展示层与旧结果业务回调的无副作用连接点。
 * @returns {React.ReactElement} 结果皮肤节点
 */
const ResultSkinContainer: React.FC<Props> = React.memo(({
  model,
  onApplyFeaturedProduct,
  onBack,
  onDownload,
  onExposeFeaturedProduct,
  onApplyRecommendedProduct,
  onRetryApplication,
  theme,
}) => (
  <ResultSkin
    model={model}
    onApplyFeaturedProduct={onApplyFeaturedProduct}
    onBack={onBack}
    onDownload={onDownload}
    onExposeFeaturedProduct={onExposeFeaturedProduct}
    onApplyRecommendedProduct={onApplyRecommendedProduct}
    onRetryApplication={onRetryApplication}
    theme={theme}
  />
))

ResultSkinContainer.displayName = 'ResultSkinContainer'

export default ResultSkinContainer
